import { render, staticRenderFns } from "./ProfitOrder.vue?vue&type=template&id=5960e2f8&scoped=true"
import script from "./ProfitOrder.vue?vue&type=script&lang=js"
export * from "./ProfitOrder.vue?vue&type=script&lang=js"
import style0 from "./ProfitOrder.vue?vue&type=style&index=0&id=5960e2f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5960e2f8",
  null
  
)

export default component.exports